import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { Product } from 'src/app/shared/models/product';
import { AddressService } from 'src/app/shared/services/address.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { PaymentService } from 'src/app/shared/services/payment.service';
import { PinDialogService } from 'src/app/shared/services/pin-dialog.service';
import { ProductService } from 'src/app/shared/services/product.service';
import { ToastService } from 'src/app/shared/services/toastr.service';
import { environment } from 'src/environments/environment';
import { SEOService } from 'src/app/common/SEOService';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

  webUrl: string;
  product: Product = new Product();
  constructor(
    private formBuilder: UntypedFormBuilder,
    private pincodeDialogService: PinDialogService,
    private addressService: AddressService,
    private apiFactory: APIFactoryEndPoints,
    private toastService: ToastService,
    private productService: ProductService,
    private navRoute: Router,
    private paymentService: PaymentService,
    private appConfig: AppConfigService,
    private seoService: SEOService
  ) { }

  ngOnInit() {
    try {
      const title = 'Secure Payment | 1 Bake Shop';
      const desc = 'Complete your order securely with our safe payment options.';
      this.seoService.updateTitle(title);
      this.seoService.updateTags([
        { name: 'description', content: desc },
        { property: 'og:title', content: title },
        { property: 'og:description', content: desc }
      ]);
      this.seoService.setCanonicalURL();
    } catch (e) {}
    this.webUrl = this.appConfig.setting.cartApiUrl;
    this.getPaymentDetails();
  }

  getPaymentDetails() {
    this.product = this.paymentService.getProduct();
    console.log(this.product);
  }
}
